import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ENV } from '../core-ng/injection-token';
import { ElementTypeRegistry } from '@hyper-inferno/survey-elements-core';

@Injectable({
  providedIn: 'root',
})
export class ElementTypeRegistryService {
  private http = inject(HttpClient);
  environment = inject(ENV);

  getElementTypes(): Observable<ElementTypeRegistry[]> {
    return this.http.get<ElementTypeRegistry[]>(
      `${this.environment.consoleApi}/element-type-registry/get-element-types`,
    );
  }
}
